import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Scrollbars from "react-custom-scrollbars";

const Container = styled.div`
  position: fixed;
  display: flex;
  box-sizing: border-box;

  border-radius: 5.615px;
  border: 1px solid #42B4E6;
  background-color: #E6E6E6;
  transition: bottom 1s, right 1s, width 1s, max-height 1s, max-width 1s, min-width 1s, padding 1s;

  @media (-webkit-min-device-pixel-ratio: 1.35) {
    -webkit-transform: scale(.7);
    transform-origin: bottom right;
  }

  @media (-webkit-min-device-pixel-ratio: 1.70) {
    -webkit-transform: scale(.6);
    transform-origin: bottom right;
  }

  ${props => props.isOpen ? `
    max-height: 30vh;
    width: 350px;
    max-width: calc(100vw - 10px);
    bottom: 0px;
    right: 0px;
  ` : `
    max-height: 0px;
    width: 0px;
    max-width: 0px;
    min-width: 0px;
    bottom: 40px;
    right: 40px;
  `}
`;

const InnerBubble = styled.div`
  position: relative;
  z-index: 3;
  ${props => props && `background-color: ${props.color || '#008a16'};color: ${props.textColor || 'white'};`}
  border-radius: 50%;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  width: 28px;
  height: 28px;
  transition: all 250ms;

  svg {
    position: relative;
    z-index: 5;
  }
`;

const InnerSquare = styled.div`
  position: absolute;
  z-index: 4;
  top: 50%;
  left: 50%;
  width: 50%;
  height: 50%;
  ${props => props && `background-color: ${props.color || '#008a16'};`}

  transition: all 250ms;
`;

const BubblePositioner = styled.div`
  position: absolute;
  left: -10px;
  top: -8px;
  z-index: 1;
`;

const WrapperBubble = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  max-width: 36px;
  max-height: 36px;
  background-color: white;
  padding: 4px;
  border-radius: 50%;
  cursor: pointer;
`;

const WrapperSquare = styled.div`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  width: 50%;
  height: 50%;
  background-color: white;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  overflow: hidden;
  ${props => props.isOpen ? `` : `
    white-space: nowrap;
  `}
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 24px;
  font-weight: 700;
  flex-wrap: wrap;
  ${props => props.isOpen ? `` : `
    flex-wrap: nowrap;
  `}
`;

const Title = styled.span`
  color:  #626469;
  font-size: 14px;
  margin-left: 5px;
  margin-right: 5px;
`;

const ActionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  min-height: 14px;
`;

const ActionLabel = styled.span`
  color: #0F81B3;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
`;

const HiddenFeedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  visibility: hidden;
`;

const FeedPositioner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 10px;
`;

const FeedWrapper = styled.div`
  position: absolute;
  top:0px;right:0px;bottom:0px;left:0px;
`;

const FeedContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 10px;
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 8px;
  right: 5px;
  box-sizing: border-box;
  min-height: 20px;
  max-height: 20px;
  min-width: 20px;
  max-width: 20px;
  color: #9FA0A4;
  cursor: pointer;
`;

const IconWrapper = styled.div`
  box-sizing: border-box;
  width: 24px;
  min-width: 24px;
  max-width: 24px;
  height: 24px;
  min-height: 24px;
  max-height: 24px;

  ${props => props.color ? `color: ${props.color};` : ''}
`;

const NotificationItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 4px;
  background: #FFF;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.20);
  margin-top: 10px;
  font-size: 12px;
  font-weight: 700;

  :first-child {
    margin-top: 0px;
  }
`;

const NotificationTextWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 5px;
  color: #626469;
  overflow: hidden;

  ${props => props.isOpen ? `` : `
    white-space: nowrap;
    flex-wrap: nowrap;
  `}
`;

const StatusText = styled.span`
  font-weight: 400;
  margin-right: 5px;
`;

const LinkWrapper = styled.div`
  margin-right: 5px;
`;

class NotificationFeed extends React.Component {
  static propTypes = {
    moduleId: PropTypes.string,
    renderProductLink: PropTypes.func,
    getLabel: PropTypes.func,
    getAndReplaceLabel: PropTypes.func,
    mobileBreakpoint: PropTypes.number,
    primaryColor: PropTypes.string,
    primaryTextColor: PropTypes.string,
    isSaving: PropTypes.bool
  };

  addNotificationToFeed = (event) => {
    const newNotificationList = [...this.state.notificationList, event.detail];
    this.updateStateIfMounted({
      notificationList: newNotificationList,
      isOpen: true,
      shouldShow: true,
    });

    if (this.scrollComponent) {
      this.scrollComponent.view.scrollTop = 0;
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      shouldShow: false,
      isOpen: false,
      notificationList: [],
      viewMore: false
    };
    document.addEventListener('iac-add-to-notification-feed', this.addNotificationToFeed);
    this._isMounted = true;
  }

  componentWillUnmount = () => {
    document.removeEventListener('iac-add-to-notification-feed', this.addNotificationToFeed);
    this._isMounted = false;
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  renderNotificationIcon = (notificationItem) => {
    let result = (<></>);

    switch (notificationItem.status) {
      case 'added':
        result = (<IconWrapper color={'#3DCD58'}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
            <path fill="currentColor" d="M512 128c212 0 384 172 384 384S724 896 512 896 128 724 128 512s172-384 384-384zm189 292c12-12 12-31 0-44-12-12-32-12-45 0L451 583l-83-85c-13-13-33-13-45 0-13 12-13 33 0 45l105 106c6 6 14 10 23 10 8 0 16-4 23-10z"/>
          </svg>
        </IconWrapper>);
        break;
      case 'removed':
        result = (<IconWrapper color={'#DC0A0A'}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
            <path fill="currentColor" d="M512,128c211.9,0,384,172.1,384,384S723.9,896,512,896S128,723.9,128,512S300.1,128,512,128z M717.5,539  c14.9-0.7,26.4-13.3,25.7-28.2c-0.7-13.9-11.8-25-25.7-25.7h-411c-14.9-0.7-27.5,10.8-28.2,25.7c-0.7,14.9,10.8,27.5,25.7,28.2  c0.8,0,1.7,0,2.5,0H717.5z"/>
          </svg>
        </IconWrapper>);
        break;
      default:
        break
    }



    return result;
  }


  renderNotificationStatus = (notificationItem) => {
    let result = '';

    switch (notificationItem.status) {
      case 'added':
        result = this.props.getLabel('options_screen.successfully_added');
        break;
      case 'removed':
        result = this.props.getLabel('options_screen.successfully_removed');
        break;
      default:
        break
    }

    return result;
  }

  renderFeed = () => {

    const baseNotifications = this.state.viewMore ? this.state.notificationList : this.state.notificationList.slice(-3);

    // Shallow copy the notifications in order not to impact the initial array.
    const notificationsToShow = [...baseNotifications];
    notificationsToShow.reverse();

    return (<>
      {notificationsToShow.length > 0 ? <>
        {notificationsToShow.map((notificationItem, idx) => {
          return (<NotificationItem key={idx}>
            {this.renderNotificationIcon(notificationItem)}
            <NotificationTextWrapper isOpen={this.state.isOpen}>
              <StatusText>
                {this.renderNotificationStatus(notificationItem)}
              </StatusText>
              <LinkWrapper>{this.props.renderProductLink(notificationItem.id)}</LinkWrapper>
              {notificationItem.slot && <StatusText>{notificationItem.slot}</StatusText>}
              {notificationItem.quantity && <StatusText>{`(${notificationItem.quantity})`}</StatusText>}
            </NotificationTextWrapper>
          </NotificationItem>);
        })}
        </> : <StatusText>{this.props.getLabel('options_screen.no_notifications')}</StatusText> }
    </>);
  }

  setScrollRef = element => {
    this.scrollComponent = element;
  };

  render = () => {
    return (
      <>
        {this.state.shouldShow && <Container isOpen={this.state.isOpen}>
          {this.state.isOpen && <CloseIcon onClick={() => {
            this.updateStateIfMounted({isOpen: false});
          }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <path fill="currentColor" d="M590.3,512l290.2,290.2c20.5,20.5,20.5,56.5,0,77.1c-12.8,10.3-25.7,15.4-38.5,15.4c-15.4,0-28.3-5.1-41.1-15.4L513.3,589.1  L223,879.3c-12.8,10.3-25.7,15.4-38.5,15.4c-15.4,0-28.3-5.1-41.1-15.4c-20.5-20.5-20.5-56.5,0-77.1L433.7,512L143.4,221.8  c-20.5-20.5-20.5-56.5,0-77.1c23.1-20.5,56.5-20.5,79.6,0l290.2,287.7L801,144.7c23.1-20.5,56.5-20.5,79.6,0  c20.5,20.5,20.5,56.5,0,77.1L590.3,512z" />
            </svg>
          </CloseIcon>}

          <BubblePositioner>
            <WrapperBubble onClick={() => {
              this.updateStateIfMounted({isOpen: true});
            }}>
              <WrapperSquare></WrapperSquare>
              <InnerBubble color={this.props.primaryColor} textColor={this.props.primaryTextColor}>
                <InnerSquare color={this.props.primaryColor}></InnerSquare>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M151 458h3c12-2 20-13 18-25-7-44 2-90 24-130 23-39 58-70 101-86 11-4 16-16 12-27s-17-17-27-13c-52 20-95 57-123 105-27 48-38 104-29 158 1 10 11 18 21 18zm720 0c11 0 20-8 21-18 9-54-2-110-29-158-28-48-71-85-122-105-11-4-24 2-28 13s1 23 12 27c43 16 78 47 101 86 22 40 31 86 24 130-2 12 6 23 18 25h3zM436 850c34 0 65-17 83-46h269c9 0 17-6 20-14s1-17-5-23c-14-14-28-29-41-45-20-25-33-102-41-148l-4-25c-8-50-21-100-39-146-18-51-56-91-105-111-8-21-27-37-50-41-32-7-64 12-76 41-49 20-87 60-104 110-19 47-32 97-40 147l-4 25c-8 46-21 123-41 148-13 16-26 31-41 45-6 6-8 15-5 23s11 14 20 14h122c11 17 28 32 47 39 12 5 24 7 35 7zm327-409c10 0 19-8 21-18 4-30-2-60-16-86-15-26-39-47-67-57-11-5-23 1-27 12s1 23 12 28c19 7 35 20 45 38s14 38 11 58c-2 12 6 23 18 25h3zm-504 0h4c11-2 19-13 17-25-3-20 1-40 12-58 9-18 25-31 44-38 11-5 17-17 12-28-4-11-16-16-27-12-28 10-52 31-66 57-16 26-21 56-17 86 2 10 11 18 21 18zm22 320c4-4 7-8 10-12 25-31 38-94 50-168l4-25c8-47 20-94 38-139 15-42 47-74 88-88 8-3 13-9 14-16 3-14 16-23 30-20 10 2 18 10 20 20 1 7 7 13 14 16 42 14 74 46 88 89 18 44 31 91 38 138l4 25c13 74 25 137 50 168l10 12H505c-8 0-16 5-19 13-11 27-42 41-69 30-13-6-24-16-30-30-3-8-11-13-19-13h-87z"/></svg>
              </InnerBubble>
            </WrapperBubble>
          </BubblePositioner>
          <Content isOpen={this.state.isOpen}>
            <TitleWrapper isOpen={this.state.isOpen}>
              <Title>{this.props.getAndReplaceLabel('options_screen.updates_for', '')}</Title>
              {this.props.renderProductLink(this.props.moduleId)}
            </TitleWrapper>
            <FeedPositioner>
              <FeedWrapper>
                <Scrollbars ref={this.setScrollRef}>
                  <FeedContent>
                    {this.renderFeed()}
                  </FeedContent>
                </Scrollbars>
              </FeedWrapper>
              <HiddenFeedWrapper>
                {this.renderFeed()}
              </HiddenFeedWrapper>
            </FeedPositioner>
            <ActionWrapper>
              {this.state.notificationList.length > 0 && <ActionLabel onClick={() => {
                this.updateStateIfMounted({
                  notificationList: [],
                  viewMore: false
                });
              }}>{this.props.getLabel('app.action.clear')}</ActionLabel>}
              {this.state.notificationList.length > 3 && <ActionLabel onClick={() => {
                this.updateStateIfMounted({
                  viewMore: !this.state.viewMore
                });
              }}>{this.props.getLabel(this.state.viewMore ? 'app.action.view_less' : 'app.action.view_more')}</ActionLabel>}

            </ActionWrapper>
          </Content>

        </Container>}
      </>
    );
  };
}

export default NotificationFeed;
